import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { selectIsReadOnly, selectUserRole } from 'store/Faraday/selectors';
import { saveTemplateFromVulnContext } from 'store/Manage/actions';
import Button from 'shared/ui/Button';
import SaveTemplateIcon from './styled';
import ModalWarning from 'Common/Components/ModalWarning';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_VULN_TEMPLATE, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const SaveAsTemplate = ({ hasVulns, vulnsSelected, entity }) => {
  const [showWarning, setShowWarning] = useState(false);
  const intl = useIntl();
  const dispatch = useDispatch();
  const title = intl.formatMessage({ id: 'manage.cm.saveAsTemplate' });
  const role = useSelector(selectUserRole);
  const readOnly = useSelector(selectIsReadOnly);
  const isAllowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_VULN_TEMPLATE, PERMISSION_TYPES.CREATE));
  const canUpdate = (entity === 'vulnsGeneral')
    ? (role !== 'client') && (role !== 'asset_owner') && hasVulns && isAllowedByRole
    : !readOnly && (role !== 'client') && (role !== 'asset_owner') && hasVulns && isAllowedByRole;
  const message = intl.formatMessage({ id: 'modalWarning.selectOneOrMore' }, { entity: 'vulnerabilities' });

  const saveTemplate = () => {
    dispatch(saveTemplateFromVulnContext(vulnsSelected, entity));
  };

  const handleClick = () => {
    if (canUpdate) {
      if (vulnsSelected.length > 0) saveTemplate();
      else setShowWarning(true);
    }
  };

  const onClose = () => setShowWarning(false);

  return (
    <>
      <Button variant="ghost" startIcon={ <SaveTemplateIcon /> } title={ title } ariaLabel={ title } onClick={ handleClick } disabled={ !canUpdate } />
      { showWarning && <ModalWarning onCloseCallback={ onClose } title={ title } description={ message } /> }
    </>
  );
};

export default SaveAsTemplate;
